{
  "Source": "Source",
  "km/h": "km/h",
  "1 month": "1 month",
  "1 week": "1 week",
  "1 year": "1 year",
  "2 years": "2 years",
  "24 hours": "24 hours",
  "3 months": "3 months",
  "3 years": "3 years",
  "4 years": "4 years",
  "6 months": "6 months",
  "8 years": "8 years",
  "A-1060 Wien, Mariahilfer Straße 77-79": "A-1060 Wien, Mariahilfer Straße 77-79",
  "Abort measurement": "Abort measurement",
  "ABORTED": "Abgebrochen",
  "Academic degree": "Academic degree",
  "Accept": "Accept",
  "access": "Access",
  "accessibility": "Accessibility",
  "Accessibility": "Accessibility",
  "Accuracy": "Accuracy",
  "additional_information": "Further information on the measurement",
  "Address is required": "Address is required",
  "address_not_distinct": "Address not distinct",
  "Advanced search": "Advanced search",
  "Agree": "Agree",
  "All provinces": "All provinces",
  "All": "All",
  "all": "All",
  "altitude": "Altitude",
  "Android app href": "https://play.google.com/store/apps/details?id=at.alladin.rmbt.android",
  "Android link": "<a href=\"https://play.google.com/store/apps/details?id=at.alladin.rmbt.android\" target=\"_blank\">Android</a>",
  "AndroidApp link": "<a href=\"https://play.google.com/store/apps/details?id=at.alladin.rmbt.android\" target=\"_blank\">Android App</a>",
  "Any": "any",
  "Apartment building": "Apartment building",
  "API": "API",
  "App and Browser Test": "App and Browser Test",
  "Apply filters": "Apply filters",
  "Are you sure you want to leave this page? The data may be lost as a result.": "Are you sure you want to leave this page? The data may be lost as a result.",
  "asn": "AS number",
  "atraster100": "Austrian 100m grid ID",
  "atraster250": "Austrian 250m grid ID",
  "austria": "Austria",
  "automatic": "Automatic",
  "Automatic": "Automatic",
  "available_history": "Test results are available under menu item <em>History</em>.",
  "Bad request": "Bad request",
  "Basic information on the certified measurement": "Basic information on the certified measurement",
  "bearing": "Bearing",
  "begin": "begin",
  "bmapgrau": "Basemap.at - grey",
  "bmaphidpi": "Basemap.at - high DPI",
  "bmaporthofoto30cm": "Basemap.at - satellite",
  "bmapoverlay": "Basemap.at - overlay",
  "osm": "OpenStreetMap",
  "Breadcrumbs": "Breadcrumbs",
  "Browser test link": "<a href=\"/en/test\" target=\"_blank\">browser test</a>",
  "Browser": "Browser",
  "bytes_download": "Data volume download",
  "bytes_upload": "Data volume upload",
  "bytes": "bytes",
  "Cadastral": "Cadastral communities",
  "Cancel": "Cancel",
  "cat_technology": "Connection Technology",
  "cell_area_code": "Cell area code",
  "cell_location_id": "Cell location id",
  "Certified measurement": "Certified measurement",
  "Certified Measurement Results": "Certified Measurement Results",
  "certified_measurement": "Certified measurement",
  "channel_number": "Frequency channel",
  "choose_server_desc": "Please choose which server should be used for conducting the WebSocket-based test.",
  "client_local_ip": "Internal IP ",
  "client_name": "Software name",
  "client_public_ip_as_name": "IP network name",
  "client_public_ip_as": "IP network (name of AS)",
  "client_public_ip_rdns": "Hostname",
  "client_public_ip": "External IP",
  "client_software_version": "Software version",
  "client_type": "RMBT type",
  "client_version": "RMBT version",
  "client_uuid": "Client UUID",
  "Client-UUID": "Client UUID",
  "Close": "Close",
  "cloud": "Cloud",
  "Code is required": "Code is required",
  "code": "Code",
  "communities": "Cadastral communities",
  "community": "Community",
  "Completed": "Completed",
  "Conduct certified measurements": "Conduct certified measurements",
  "Conduct repeated measurements": "Conduct repeated measurements",
  "conducting_measurements": "Conduction of the measurement",
  "connection_technology": "Technology",
  "connection": "NAT status",
  "content_block": "In compliance with the RTR-NetTest privacy policy the measurement results of the RTR-NetTest are available as Open Data. The <a href=\"/en/OpenDataSpecification.html\">specification is available as HTML</a> and <a href=\"https://github.com/rtr-nettest/open-rmbt/blob/master/RMBTStatisticServer/doc/swagger.json\">Swagger</a>. This specification describes the information which is available as Open Data. It is available as JSON and as CSV-file (see below).",
  "Coordinates": "Coordinates",
  "corine_100": "Artificial surfaces",
  "corine_110": "Urban fabric",
  "corine_111": "Continuous urban fabric",
  "corine_112": "Discontinuous urban fabric",
  "corine_120": "Industrial, commercial and transport units",
  "corine_121": "Industrial or commercial units",
  "corine_122": "Road and rail networks and associated land",
  "corine_123": "Port areas",
  "corine_124": "Airports",
  "corine_130": "Mine, dump and construction sites",
  "corine_131": "Mineral extraction sites",
  "corine_132": "Dump sites",
  "corine_133": "Construction sites",
  "corine_140": "Artificial non-agricultural vegetated areas",
  "corine_141": "Green urban areas",
  "corine_142": "Sport and leisure facilities",
  "corine_200": "Agricultural areas",
  "corine_210": "Arable land",
  "corine_211": "Non-irrigated arable land",
  "corine_212": "Permanently irrigated land",
  "corine_213": "Rice fields",
  "corine_220": "Permanent crops",
  "corine_221": "Vineyards",
  "corine_222": "Fruit trees and berry plantations",
  "corine_223": "Olive groves",
  "corine_230": "Pastures",
  "corine_231": "Pastures",
  "corine_240": "Heterogeneous agricultural areas",
  "corine_241": "Annual crops associated with permanent crops",
  "corine_242": "Complex cultivation patterns",
  "corine_243": "Land principally occupied by agriculture, with significant areas of natural vegetation",
  "corine_244": "Agro-forestry areas",
  "corine_300": "Forests and semi-natural areas",
  "corine_310": "Forests",
  "corine_311": "Broad-leaved forest",
  "corine_312": "Coniferous forest",
  "corine_313": "Mixed forest",
  "corine_320": "Shrub and/or herbaceous vegetation association",
  "corine_321": "Natural grassland",
  "corine_322": "Moors and heathland",
  "corine_323": "Sclerophyllous vegetation",
  "corine_324": "Transitional woodland shrub",
  "corine_330": "Open spaces with little or no vegetation",
  "corine_331": "Beaches, dunes, and sand plains",
  "corine_332": "Bare rock",
  "corine_333": "Sparsely vegetated areas",
  "corine_334": "Burnt areas",
  "corine_335": "Glaciers and perpetual snow",
  "corine_400": "Wetlands",
  "corine_410": "Inland wetlands",
  "corine_411": "Inland marshes",
  "corine_412": "Peatbogs",
  "corine_420": "Coastal wetlands",
  "corine_421": "Salt marshes",
  "corine_422": "Salines",
  "corine_423": "Intertidal flats",
  "corine_500": "Water bodies",
  "corine_510": "Inland waters",
  "corine_511": "Water courses",
  "corine_512": "Water bodies",
  "corine_520": "Marine waters",
  "corine_521": "Coastal lagoons",
  "corine_522": "Estuaries",
  "corine_523": "Sea and ocean",
  "Could not load the map style": "Could not load the map style",
  "country_asn": "Country of AS",
  "country_geoip": "Country of IP",
  "country_location": "Country of location",
  "Coverage": "Coverage",
  "Coverage series": "Coverage series",
  "csv_interface": "Download interface",
  "csv": "CSV",
  "current_test": "Current measurement",
  "Currently there are no statistics available.": "Currently there are no statistics available.",
  "Data volume": "Data volume",
  "Data": "Data",
  "Date": "Date",
  "date": "date",
  "Days": "Days",
  "dB": "dB",
  "dBm": "dBm",
  "Default server": "Default server",
  "Describe the computer that you are running the test with.": "Describe the computer that you are running the test with. How is the computer connected to the modem/router? Are your devices connected wired (LAN) or wireless (WLAN)? Are the electrical wires in your house also used to transmit data (PowerLAN)? For WLAN: Are the test device and modem / router in the same room?",
  "Detailed results": "Detailed results",
  "detailed_measurements": "Detailed measurements",
  "Details": "Details",
  "Device": "Device",
  "devices": "Devices",
  "Disable map": "Disable map",
  "Dismiss": "Dismiss",
  "distance": "Movement",
  "district": "District",
  "Down (Mbps)": "Down (Mbps)",
  "down_avg": "DL (normal)",
  "down_max": "DL (max)",
  "Down": "Down",
  "DOWN": "Download",
  "Download %ios or %androidApp or conduct %web.": "Download %ios or %androidApp or conduct %web.",
  "Download %ios, %android or %desktop or conduct %web.": "Download %ios, %android or %desktop or conduct %web.",
  "Download details": "Download details",
  "Download PDF": "Download PDF",
  "download_kbit_from": "Download",
  "download_kbit": "Download speed",
  "download_results": "Download results:",
  "download": "Download",
  "Download": "Download",
  "Download/Upload": "Download/Upload",
  "dtm_level": "DTM altitude",
  "dtm_level_units": "m",
  "Duration": "Duration",
  "duration_download_ms": "Duration download",
  "duration_upload_ms": "Duration upload",
  "duration": "Test duration",
  "E-Mail: netztest@rtr.at": "E-Mail: <a href=\"mailto:netztest@rtr.at?subject=RTR-NetTest%20support%20request\">netztest@rtr.at</a>",
  "edge_id": "Street edge ID",
  "encryption_false": "No",
  "encryption_true": "Yes",
  "encryption": "RMBT encryption",
  "End date": "End date",
  "end": "end",
  "END": "Finished",
  "Enter synchronization code": "Enter synchronization code",
  "enter_code": "or enter a known synchronization code in the input box below and confirm your entry by clicking on submit",
  "Environment": "Environment",
  "error_during_test": "An error occurred during the measurement.",
  "error_generating": "Error generating the document.",
  "ERROR": "Error",
  "error": "Error",
  "esri": "Basemap.at - isolines",
  "Estimated end time": "Estimated end time",
  "Exit": "Exit",
  "Explore open data test results": "Explore open data test results",
  "external_ip": "External IP",
  "Failed to load map, please retry later": "Failed to load map, please retry later",
  "Fence time": "Fence time",
  "Fences heading": "Fences heading",
  "Fences Lorem Ipsumen": "Fences Lorem Ipsumen",
  "fences": "fences",
  "filter_map": "Filter map",
  "finished_desc": "Save the result of the measurement cycle immediately or print it out. The document will not be saved by RTR-GmbH.",
  "finished": "Finished",
  "First name is required": "First name is required",
  "First name": "First name",
  "fix_threads": "lock parallel threads",
  "Footer navigation": "Footer navigation",
  "For this location, no provider open data is available.": "For this location, no provider open data is available.",
  "Forbidden": "Forbidden",
  "from_value": "from",
  "from": "from",
  "Further filters": "Further filters",
  "Further information on the certified measurement": "Further information on the certified measurement",
  "further_results": "Further results are available on a monthly basis:",
  "further_tests": "Further tests",
  "further": "Further",
  "Further": "Further",
  "gaming_cloud": "Gaming Cloud",
  "gaming_download": "Gaming Download",
  "gaming_streaming": "Gaming Streaming",
  "gaming": "Gaming",
  "Gbps": "Gbps",
  "generate_new": "Try again",
  "generating_report": "Document is being created ...",
  "Get forum banner": "Get forum banner",
  "gkz_from": "Austrian community ID",
  "gkz": "Austrian community ID",
  "heatmap": "Heatmap",
  "Heatmap": "Heatmap",
  "help_url": "https://www.rtr.at/en/tk/netztesthilfe",
  "help": "Help",
  "Help": "Help",
  "Histogram": "Histogram",
  "history": "History",
  "History": "History",
  "Home": "Home",
  "hostname": "Hostname",
  "https://www.github.com/rtr-nettest/": "https://www.github.com/rtr-nettest/",
  "https://www.netztest.at/redirect/en/help": "https://www.netztest.at/redirect/en/help",
  "https://www.netztest.at/redirect/en/terms": "https://www.netztest.at/redirect/en/terms",
  "https://www.rtr.at/en/tk/rtrnetztest_tests": "https://www.rtr.at/en/tk/rtrnetztest_tests",
  "https://www.rtr.at/medien/startseite_medien.de.html": "https://www.rtr.at/medien/startseite_medien.de.html",
  "https://www.rtr.at/rtr/footer/Barrierefreiheit.en.html": "https://www.rtr.at/rtr/footer/Barrierefreiheit.de.html",
  "https://www.rtr.at/rtr/footer/impressum.en.html": "https://www.rtr.at/rtr/footer/impressum.en.html",
  "https://www.rtr.at/rtr/startseite.de.html": "https://www.rtr.at/rtr/startseite.de.html",
  "https://www.rtr.at/TKP/Telecommunications_and_Postal_Division.en.html": "https://www.rtr.at/TKP/Telecommunications_and_Postal_Division.en.html",
  "I agree to the terms of use and privacy policy": "I agree to the <a href='https://www.rtr.at/de/tk/rtrnetztesttermsofuse'>terms of use</a> and <a href='https://www.rtr.at/de/tk/netztestprivacypolicyweb'>privacy policy</a>",
  "implausibleResult": "Comment: Implausible test result. Test is ignored.",
  "imprint_url": "https://www.rtr.at/en/rtr/impressum",
  "imprint": "Publishing information",
  "index": "Home",
  "Info": "Info",
  "INIT_DOWN": "Initializing",
  "INIT_UP": "Init Upload",
  "INIT": "Initializing",
  "Intraday": "Intraday",
  "iOS app href": "/redirect/app-ios",
  "iOS link": "<a href=\"/redirect/app-ios\" target=\"_blank\">iOS</a>",
  "ip_anonym": "IP (anonymized)",
  "IP-Version description": "If your internet access supports both IPv4 and IPv6, you can choose which protocol version is used for conducting the test.",
  "IP-Version": "IP-Version",
  "ip": "IP",
  "ipvX_only": "IPv%X% only",
  "Is it the first measurement cycle?": "Is it the first measurement cycle?",
  "java_applet": "Java-Applet",
  "KB": "KB",
  "kbps": "kbps",
  "land_cover_cat1": "Land cover (category)",
  "land_cover_cat2": "Land cover (subcategory)",
  "land_cover": "Land cover",
  "Language": "Language",
  "Last name is required": "Last name is required",
  "Last name": "Last name",
  "Last updated": "Last updated",
  "Layers": "Layers",
  "less": "less",
  "Less": "Less",
  "license_text": "The data is published under the <a href=\"https://creativecommons.org/licenses/by/4.0/deed.de\" target=\"_blank\">Creative Commons Attribution 4.0 (CC BY 4.0)</a> license. Please also refer the additional <a rel=\"license\" href=\"https://www.rtr.at/TKP/service/rtr-nettest/help/legal_aspects/netztest_3rd_party_open_data.en.html\">licensing terms</a>.",
  "link_distance": "Street distance",
  "link_frc": "Street category",
  "link_id": "Street link ID",
  "link_name": "Street identifier",
  "link_name1": "Street name1",
  "link_name2": "Street name2",
  "Linux link": "<a href=\"/redirect/desktop-linux\" target=\"_blank\">Desktop App</a>",
  "LiveMapOverlayMessage": "Press \"m\" or tap the fullscreen button to open the map in the fullscreen mode.",
  "Loading IP information...": "Loading IP information...",
  "Loading results": "Loading results",
  "loc_accuracy_from": "Location accuracy",
  "locality": "Cadastral community",
  "Location accuracy": "Location accuracy",
  "Location details": "Location details",
  "Location is required": "Location is required",
  "Location of the measurements": "Location of the measurements (address at which the measurements are taken)",
  "location_desc": "The address at which the measurements are taken",
  "location": "Location",
  "Loop mode": "Loop mode",
  "Loop mode series": "Loop mode series",
  "loop_mode": "Loop mode",
  "lte_rsrp": "Signal strength (RSRP)",
  "lte_rsrq": "Signal quality (RSRQ)",
  "Mac link": "<a href=\"/redirect/desktop-mac\" target=\"_blank\">Desktop App</a>",
  "mailto:netztest@rtr.at?subject=Supportanfrage%20RTR-Netztest%20%28Web%29": "mailto:netztest@rtr.at?subject=Support request%20RTR-Netztest%20%28Web%29",
  "Main navigation": "Main navigation",
  "Maintenance": "Maintenance",
  "Map key": "Map key",
  "Map type": "Map type",
  "Map view": "Map view",
  "Map with test results": "Map with test results",
  "map_key": "Map key",
  "map": "Map view",
  "MB": "MB",
  "mbps": "Mbps",
  "Mbps": "Mbps",
  "Measurement result from": "Measurement result from",
  "Measurement result": "Measurement result",
  "Measurement": "Measurement",
  "Measurements": "Measurements",
  "Measurement failed": "Measurement failed",
  "Media": "Media",
  "Menu": "Menu",
  "menu": "Menu",
  "messaging": "Messaging",
  "Method not allowed": "Method not allowed",
  "millis": "ms",
  "Mio_abbr": "m",
  "Mixed": "Mixed",
  "mobile_provider_name": "Mobile provider",
  "Mobile": "Mobile",
  "model_native": "Model (native)",
  "model": "Model",
  "Months": "Months",
  "more": "more",
  "More": "More",
  "More details": "Further details",
  "moreInfo": "More Info",
  "motion": "Motion",
  "name": "Name",
  "Name": "Name",
  "nat_type": "NAT status",
  "ndt_details_diag": "Details NDT (diag)",
  "ndt_details_main": "Details NDT (main)",
  "ndt_details_stat": "Details NDT (stat)",
  "ndt_download_kbit": "NDT-data rate download",
  "ndt_upload_kbit": "NDT-data rate upload",
  "net": "Net",
  "Network error": "Network error",
  "network_country": "Country of network",
  "network_mcc_mnc": "Mobile network MCC-MNC",
  "network_name": "Network (display)",
  "network_operator_name": "Network (display)",
  "network_operator": "Mobile network",
  "network_sim_operator_name": "Home network (display)",
  "network_sim_operator": "Home network",
  "network_type": "Network type",
  "New measurement": "New measurement",
  "next_page": "Next page",
  "Next": "Next",
  "Next measurement in": "Next measurement in",
  "Not available": "Not available",
  "No results available": "No results available",
  "No, follow-up cycle": "No, follow-up cycle",
  "Not found": "Not found",
  "note_browser": "Certified measurements can only be done via an Internet browser (Chrome, Edge, Firefox etc.) on your computer.",
  "note_fixed": "The certified measurement can only be used to verify wired Internet access services.",
  "note_no_other_usage": "During a measurement cycle, do not use your computer for other applications.",
  "note_no_other_users": "In addition please make sure that you or other users do not use the same Internet connection during the measurement (eg. family members by smartphone).",
  "note_timestamp": "Please note that time stamps are in UTC (not in local time). To ensure the correctness of the results, implausible and/or obvious abusive measurements may be marked with the flag \"implausible\" by RTR.",
  "num_threads_requested": "Connections requested",
  "num_threads_ul": "Parallel connections UL",
  "num_threads": "Parallel connections DL",
  "Number of tests in loop mode": "Number of tests in loop mode",
  "Offset": "Offset",
  "Open data": "Open data",
  "Open Source": "Open Source",
  "open_data_entry": "Open data entry",
  "open_data_specification": "Open Data Interface Specification",
  "open_test_uuid": "Open Test UUID",
  "open_uuid": "Open User UUID",
  "opendata": "Open data",
  "opentest": "Open data measurement result",
  "opentests": "Open data measurement results",
  "operator": "Provider",
  "options": "Options",
  "Options": "Options",
  "os_version": "Platform version",
  "Other desktop app link": "<a href=\"https://www.rtr.at/en/tk/rtrnetztest_tests\" target=\"_blank\">Desktop App</a>",
  "Other location description": "Other location description",
  "Other": "Other",
  "Page Not Found": "Page Not Found",
  "pdf": "PDF",
  "Photo upload": "Photo upload",
  "Ping (ms)": "Ping (ms)",
  "Ping details": "Ping details",
  "ping_ms_from": "Ping",
  "ping_ms": "Ping",
  "ping_ndt": "Latency (NDT)",
  "ping_shortest": "Ping",
  "Ping": "Ping",
  "PING": "Ping",
  "pinned_false": "Not included in statistics",
  "pinned_true": "Included in statistics",
  "pinned": "Pinned",
  "planned_end": "Planned completion of the measurement: approx. %X%.",
  "platform": "Platform",
  "plattform": "Platform",
  "Please describe the location of your Internet access": "Please describe the location of your Internet access",
  "Please describe your device used for measuring": "Please describe your device used for measuring",
  "Please describe your Internet access": "Please describe your Internet access",
  "Please select": "Please select",
  "Please send us a photo of the modem": "Please send us a photo of the modem / router, the computer (if possible together on one picture) and photos of the individual type designations. If possible, please also send a photo of the wall socket",
  "Please use the Chrome browser!": "Please use the Chrome browser!\nYou are currently using Firefox, but for high speed certified measurements we recommend to use the Chrome browser. The certified measurement is therfore not possible.",
  "please_note": "Please note in particular:",
  "points": "points",
  "Points": "Points",
  "port": "Testserver port",
  "Position": "Position",
  "preferred_test_type": "Preferred Test Type",
  "Press 'Enter' to start test or 'T' to go to the top of the page": "Press \"Enter\" to start test or \"T\" to go to the top of the page",
  "print": "Print",
  "Privacy Policy and Terms of Use": "Privacy Policy and Terms of Use",
  "privacy": "Privacy",
  "Privacy": "Privacy",
  "process_desc": "A measuring cycle lasts at least two hours. During this period, individual measurements are carried out automatically every 15 minutes. At least three measurement cycles must be performed on three different days within a timeframe of two weeks in order to get a certified measurement.",
  "process": "Process of a certified measurement",
  "provider_name": "Operator",
  "Provider": "Provider",
  "Provider/device": "Provider/device",
  "Providers from": "Providers from",
  "province": "Province",
  "public_ip_as_name": "IP network name",
  "Publishing information": "Publishing information",
  "qos": "QoS tests",
  "Quality": "Quality",
  "Quantile": "Quantile",
  "quantity": "Quantity",
  "Quantity": "Quantity",
  "questions_desc": "For questions about the certified measurement, please contact <a href=\"mailto:netztest@rtr.at\"> netztest@rtr.at </a>.",
  "radio_band": "Radio band",
  "Radius": "Radius",
  "Recent measurements": "Recent measurements",
  "Recent tests": "Recent tests",
  "recent_tests_hours": "The results of the last 48 hours are available as zip-archive under <a href=\"/RMBTStatisticServer/export/netztest-opendata_hours-048.zip\" title=\"RTR-Netztest Open Data 48h\" target=\"_blank\">netztest-opendata_hours-048.zip</a> and as xlsx under <a href=\"/RMBTStatisticServer/export/netztest-opendata_hours-048.xlsx\" title=\"RTR-Netztest Open Data 48h\" target=\"_blank\" class=\"external-link-new-window\">netztest-opendata_hours-048.xlsx</a>.",
  "recent_tests": "Recent tests",
  "referenced_signal_received_quality": "Reference signal received quality",
  "Request synchronization code": "Request synchronization code",
  "Reset": "Reset",
  "result_when_finished": "Your measurement result will be available for download after completion of all measurements.",
  "Result": "Result",
  "Result of measurement %0 - waiting": "Result of measurement %0 - waiting",
  "Results": "results",
  "roaming_international": "international roaming",
  "roaming_national": "national roaming",
  "roaming_none": "not roaming",
  "roaming_type": "Roaming status",
  "roaming": "Roaming",
  "Row details": "Row details",
  "RTR Navigation": "RTR Navigation",
  "RTR-NetTest could not be loaded. Please check the iframe tag.": "RTR-NetTest could not be loaded. Please check the iframe tag.",
  "RTR-NetTest": "LENS",
  "RTR": "RTR",
  "Run test again": "Run test again",
  "run_ndt": "I wish to run the optional NDT-Test.",
  "RUNDFUNK UND TELEKOM REGULIERUNGS-GMBH": "RUNDFUNK UND TELEKOM\nREGULIERUNGS-GMBH",
  "Rural area": "Rural area",
  "save_results": "Save results",
  "save": "Save",
  "Scroll to bottom to continue": "Scroll to bottom to continue",
  "Search for an address or city": "Search for an address or city",
  "search": "Search",
  "send_email": "Send email",
  "server_ip": "Testserver IP",
  "server_location_name": "Testserver location",
  "server_name": "Testserver name",
  "Settings": "Settings",
  "settlement_type_1": "No settlement area",
  "settlement_type_2": "Habitable area",
  "settlement_type_3": "Settlement area",
  "settlement_type": "Settlement type",
  "shapes": "Shapes",
  "Share on Facebook": "Share on Facebook",
  "Share on Twitter": "Share on Twitter",
  "Share via WhatsApp": "Share via WhatsApp",
  "share": "Share",
  "Share": "Share",
  "Show additional information...": "Show additional information...",
  "Show details": "Show details",
  "Show Open-Test-UUID": "Show Open Test UUID",
  "Show surrounding measurements as open data": "Show surrounding measurements as open data",
  "Signal (dBm)": "Signal (dBm)",
  "Signal details": "Signal details",
  "Signal measurement": "Signal measurement",
  "signal_strength_from": "Signal strength",
  "signal_strength": "Signal strength",
  "Signal strength": "Signal strength",
  "Signal": "Signal",
  "sim_country": "SIM home country",
  "sim_home_country": "SIM home country",
  "sim_mcc_mnc": "Home network MCC-MNC",
  "Since this is the first measurement cycle, we ask you to answer the following questions": "Since this is the first measurement cycle, we ask you to answer the following questions in order to understand the circumstances of the measurement. For further measuring cycles, answering these questions is no longer necessary.",
  "Single-family home": "Single-family home",
  "Skip to main content": "Skip to main content",
  "software_version": "Software version",
  "Something went wrong": "Something went wrong",
  "source_code_github": "Source Code on GitHub",
  "Sources: RTR, basemap.at, ArcData, Statistik Austria, BEV": "Sources: RTR, <a href=\"http://www.basemap.at/\" target=\"_blank\">basemap.at</a>, ArcData, Statistik Austria, BEV",
  "sources": "Sources",
  "Speed curve": "Speed curve",
  "speed_download_ndt": "Download (NDT)",
  "speed_download": "Download speed",
  "speed_upload_ndt": "Upload (NDT)",
  "speed_upload": "Upload speed",
  "Speed": "Speed",
  "Start certified measurement": "Start certified measurement",
  "Start loop mode": "Start loop mode",
  "Start measurement": "Start measurement",
  "Start RTR-NetTest": "Start RTR-NetTest",
  "Start test": "Start test",
  "start_test": "Start test",
  "Statistics on the results": "Statistics on the results",
  "statistics": "Statistics",
  "Statistics": "Statistics",
  "status": "Status",
  "streaming_audio_streaming": "Audio streaming",
  "Submit": "Submit",
  "Synchronization code": "Synchronization code",
  "Technology": "Technology",
  "Tel.: +43 1 58058-0": "Tel.: +43 1 58058-0",
  "Telecommunications and Postal Division": "Telecommunications and Postal Division",
  "temperature": "Device temperature",
  "test_duration": "Nominal test duration",
  "test_if_bytes_download": "Data if_dl",
  "test_if_bytes_upload": "Data if_ul",
  "test_results": "Test results",
  "Test server": "Testserver",
  "test": "Test",
  "Test": "Test",
  "testdl_if_bytes_download": "Data if_dl (dl-test)",
  "testdl_if_bytes_upload": "Data if_ul (dl-test)",
  "Test failed": "Test failed",
  "tests": "Number of tests",
  "testul_if_bytes_download": "Data if_dl (ul-test)",
  "testul_if_bytes_upload": "Data if_ul (ul-test)",
  "The configuration has been saved.": "The configuration has been saved.",
  "The measurement is not configured. Please fill the form and try again.": "The measurement is not configured. Please fill the form and try again.",
  "The test has finished. Showing the results page.": "The test has finished. Showing the results page.",
  "Thou_abbr": "k",
  "Time span": "Time span",
  "time_dl_ms": "Rel. start download",
  "time_dl_ns": "Start time download",
  "time_from": "Timespan begin",
  "time_to": "Timespan end",
  "time_ul_ms": "Rel. start upload",
  "time_ul_ns": "Start time upload",
  "time": "time",
  "Time": "Time",
  "Timespan": "Timespan",
  "Time Unit": "Time Unit",
  "timezone": "Timezone",
  "timing_advance": "Timing Advance",
  "Title": "Title",
  "to_value": "to",
  "top": "Top",
  "total_bytes": "Data amount RMB-Test",
  "total_if_bytes": "Data amount interface",
  "type": "Type",
  "Unauthorized": "Unauthorized",
  "Unknown": "-",
  "Unsupported media type": "Unsupported media type",
  "Up (Mbps)": "Up (Mbps)",
  "up_avg": "UL (normal)",
  "up_max": "UL (max)",
  "up_to": "up to",
  "Up": "Up",
  "UP": "Upload",
  "Upload details": "Upload details",
  "Upload file": "Upload file",
  "upload_kbit_from": "Upload",
  "upload_kbit": "Upload speed",
  "upload": "Upload",
  "Upload": "Upload",
  "Urban area": "Urban area",
  "uuid": "Test UUID",
  "video_conferencing": "Video Conference",
  "video_hd": "Videos HD",
  "video_sd": "Videos SD",
  "video_telephony": "Video Telephony",
  "video_uhd": "Videos 4k",
  "voip": "VoIP",
  "WAIT": "Waiting for test slot",
  "Waiting": "Waiting",
  "Waiting progress": "Waiting progress",
  "Waiting time (in minutes) between two tests in loop mode": "Waiting time (in minutes) between two tests in loop mode",
  "Waiting time": "Waiting time",
  "web": "Web",
  "websocket": "WebSocket",
  "What kind of Internet access do you have?": "What kind of Internet access (DSL, cable, radio, other) do you have? Which modem or which router do you use? If possible, specify an exact type designation.",
  "wifi_bssid": "WLAN BSSID",
  "wifi_link_speed": "WLAN Connection Speed",
  "wifi_ssid": "WLAN SSID",
  "Windows link": "<a href=\"/redirect/desktop-win\" target=\"_blank\">Desktop App</a>",
  "Wlan App": "WLAN (App)",
  "X_recent_tests": "%X% recent tests",
  "xlsx": "XLSX",
  "Years": "Years",
  "Yes, first cycle": "Yes, first cycle",
  "Your IP address": "Your IP address",
  "Your UUID is: %0": "Your UUID is: %0",
  "YourSyncCode": "Your synchronization code is",
  "zip_code": "ZIP code"
}
